import './services_list.css';
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "react-js-pagination";
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import { makeStyles } from '@mui/styles';
import Loading_animation_view from '../../loading_animation_view/loading_animation_view'
import { archive_service, get_all_departments, get_services } from '../../../services/company_admin_service';
import Update_serv_modal from './update_serv_modal/update_serv_modal';
import { get_active_habilitations } from '../../../services/habilitations service';




const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

const columns = [
    { id: 'fullName', label: "Nom complet", minWidth: 0 },
    { id: 'service', label: "Service", minWidth: 0 },
    { id: 'cnss', label: "cnss", minWidth: 0 },
    { id: 'phnumber', label: "Téléphone", minWidth: 0 },
    { id: 'created_at', label: "Date de d'ajout", minWidth: 0 },
    { id: 'service_stat', label: "Statut de service", minWidth: 0 },
];


function state(service_state) {
    return (
        <>
            {
                service_state === 1
                    ? <Button variant="contained" className="status_deny">{"archivée"}</Button>
                    : <Button variant="contained" className="status_success">{"non archivée"}</Button>
            }
        </>

    );
}

function role(service_role) {
    return (
        <>
            {
                service_role === 1
                    ? <>{"service d'achat"}</>
                    : service_role === 2
                        ? <>{"service métier"}</>
                        : <>{"service de finance"}</>
            }
        </>

    );
}

function Services({ services, dont_archive, archive, setupdate_service }) {

    return (
        <>
            {
                services.map((service, id) => (
                    <TableRow key={"service" + id}>
                        <TableCell align="left">
                            <div style={{ width: 'fit-content' }}>
                                {service.fullName}
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <Tooltip title="modifier" placement="top" >
                                        <span className={"editIcon"} onClick={() => setupdate_service(service)} >
                                            <EditIcon className="my_icon" style={{ cursor: 'pointer' }} />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        </TableCell>
                        <TableCell align="left">{role(service.role)}</TableCell>
                        <TableCell align="left">{service.cnss}</TableCell>
                        <TableCell align="left">{service.phoneNumber}</TableCell>
                        <TableCell align="left">{(new Date(service.created_at)).toLocaleString().split(' ')[0]}</TableCell>
                        <TableCell align="center">
                            <div className='documentsStatus_valide'  >
                                <div>
                                    <div><CheckIcon className="checkIcon" onClick={() => dont_archive(id, service.id)} /></div>
                                    <div><CloseSharpIcon className="closeSharpIcon" onClick={() => archive(id, service.id)} /></div>
                                </div>
                                {state(service.archived)}
                            </div>
                        </TableCell>
                    </TableRow>
                ))
            }
        </>
    );
}



function Services_list() {

    const classes = useStyles();
    const [url_updated, setUrl_updated] = useState(null);
    let history = useHistory();

    const [service_role, setservice_role] = useState("default");
    const [service_state, setservice_state] = useState("default");
    const [services, setservices] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [search_value, setsearch_value] = useState("");

    const [available_habilitations, setavailable_habilitations] = useState([]);

    const [waiting, setWaiting] = useState(false);
    const [update_service, setupdate_service] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(10);
    const [data_count, setdata_count] = useState(0);

    useEffect(() => {
        async function load_data() {
            await get_active_habilitations().then((response) => {
                setavailable_habilitations(response.data);
                //  console.log(response.data);
            }).catch((error) => {
                //  console.log(error.response);
            })

            await get_all_departments().then((response) => {
                setDepartments(response.data);
                //  console.log(response.data);
            }).catch((error) => {
                //  console.log(error.response);
            })
        }
        load_data();
    }, [])

    useEffect(() => {
        setdata_count(0);
        setservices(null);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let service_state_tmp = "default"
        let service_role_tmp = "default"
        let tmp_searchValue = "null";

        async function load_data() {
            if (urlParams.get('valeur')) {
                tmp_searchValue = urlParams.get('valeur');
                setsearch_value(tmp_searchValue === "null" ? null : tmp_searchValue);
            }
            if (urlParams.get('serv_statut')) {
                service_state_tmp = urlParams.get('serv_statut');
                setservice_state(service_state_tmp);
            }
            if (urlParams.get('serv')) {
                service_role_tmp = urlParams.get('serv');
                setservice_role(service_role_tmp);
            }
            let page = (urlParams.get('page') ? urlParams.get('page') : 1);
            await setCurrentPage(page);

            await get_services(service_role_tmp, service_state_tmp, tmp_searchValue, page).then((response) => {
                setdata_count(response.data.total)
                setservices(response.data.data);
                //console.log(response.data.data);
            }).catch((error) => {
                //console.log(error.response);
            });
        }

        load_data();

    }, [url_updated, history.location]);



    function select_service_role(value) {
        setservice_role(value);
        let path = window.location.href.split('?')[0]
        window.location.href = path + "?serv=" + value;
    }

    function select_service_stat(value) {
        setservice_state(value);
        let path = window.location.href.split('?')[0]
        if (service_role === "default") window.location.href = path + "?serv_statut=" + value;
        else window.location.href = path + "?serv=" + service_role + "&serv_statut=" + value;
    }

    function dont_archive(id, service_id) {
        setWaiting(true);
        let formData = new FormData();
        formData.append('service_id', service_id);
        formData.append('archive', 0);
        archive_service(formData).then((response) => {
            let tmp_arr = [...services];
            tmp_arr[id].archived = 0;
            setservices(tmp_arr);
            setWaiting(false);
        }).catch((error) => {
            //console.log(error.response);
            setWaiting(false);
        })
    }

    function archive(id, service_id) {
        setWaiting(true);
        let formData = new FormData();
        formData.append('service_id', service_id);
        formData.append('archive', 1);
        archive_service(formData).then((response) => {
            let tmp_arr = [...services];
            tmp_arr[id].archived = 1;
            setservices(tmp_arr);
            setWaiting(false);
        }).catch((error) => {
            //console.log(error.response);
            setWaiting(false);
        })
    }

    async function change_page(page) {
        await setCurrentPage(page);
        let path = history.location.pathname;
        let params = history.location.search;
        let search_params = params.split('&');
        let tmp_params = path;
        if (!params) history.push(path + "?page=" + page);
        else {
            for (let i in search_params) {
                if (search_params[i].includes("page=")) {
                    if (i == 0) tmp_params = tmp_params + "?page=" + page;
                    else tmp_params = tmp_params + "&page=" + page;
                } else {
                    if (i == 0) tmp_params = tmp_params + search_params[i];
                    else tmp_params = tmp_params + "&" + search_params[i];
                }
            }
            if (!tmp_params.includes("page=")) tmp_params = tmp_params + "&page=" + page;
            history.push(tmp_params);
        }
        await setUrl_updated(page);
    }



    function search() {
        let path = history.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        //  console.log(search_value);
        if (search_value && search_value.trim() !== "") {
            urlParams.set("valeur", search_value);
        } else {
            urlParams.delete("valeur");
        }

        history.push(`${path}?${urlParams.toString()}`);
        setUrl_updated(search_value);
    }

    function reset_search() {
        let path = history.location.pathname;
        history.push(path);
        setsearch_value("");
        setUrl_updated("reset");
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            search();
        }
    };


    return (
        <>
            {
                services == null
                    ? <Loading_animation_view />
                    : <div className='services_list_container'>
                        <div className='services_list_container_header'>
                            <div className='title_container'><label>Services</label></div>
                            <div className='search_filter_container'>
                                <FormControl variant='standard' className="header_form" >
                                    <InputLabel>Services</InputLabel>
                                    <Select required
                                        value={service_role}
                                        onChange={e => {
                                            select_service_role(e.target.value);
                                        }} name="Etat" >
                                        <MenuItem value={"default"}>
                                            Tous les services
                                        </MenuItem>
                                        <MenuItem value={1}>{"service d'achat"}</MenuItem>
                                        <MenuItem value={2}>{"service métier"}</MenuItem>
                                        <MenuItem value={3}>{"service de finance"}</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl variant='standard' className="header_form" >
                                    <InputLabel>Etat de service</InputLabel>
                                    <Select required
                                        value={service_state}
                                        onChange={e => {
                                            select_service_stat(e.target.value);
                                        }} name="Etat" >
                                        <MenuItem value={"default"} disabled>
                                            Etat de service
                                        </MenuItem>
                                        <MenuItem value={"recent"}>Récent</MenuItem>
                                        <MenuItem value={"old"}>Ancien</MenuItem>
                                        <MenuItem value={"archived"}>Archivée</MenuItem>
                                        <MenuItem value={"no_archived"}>Non Archivée</MenuItem>
                                    </Select>
                                </FormControl>

                                <Grid container spacing={1} alignItems="flex-start" className="search_bar">
                                  {/*   <Grid item>
                                        <SearchIcon onClick={search} className={search_value === "" ? "my_icon disabled_button" : "my_icon"} style={{ cursor: "pointer" }} />
                                    </Grid> */}
                                    <Grid>
                                        <TextField variant='standard' label="Chercher" value={search_value} onKeyDown={handleKeyDown} onChange={(e) => { setsearch_value(e.target.value) }} />
                                    </Grid>
                                    <Grid item style={{ marginLeft: "5px" }}>
                                        <CloseIcon onClick={reset_search} className={search_value === "" ? "my_icon disabled_button" : "my_icon"} style={{ cursor: "pointer" }} />
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                        <TableContainer className="services_list_table">
                            <Table className={classes.table} aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            columns.map((column) => (
                                                <TableCell key={column.id} align="left">{column.label}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        services.length !== 0
                                            ?
                                            <>
                                                <Services services={services} dont_archive={dont_archive} archive={archive} setupdate_service={setupdate_service} />
                                            </>
                                            : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun service disponible</div>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {
                            services.length !== 0
                                ? <div className="pagination_container">
                                    <Pagination
                                        activePage={Number(currentPage)}
                                        itemsCountPerPage={dataPerPage}
                                        totalItemsCount={Number(data_count)}
                                        pageRangeDisplayed={4}
                                        onChange={change_page.bind(this)}
                                    />
                                </div>
                                : <></>
                        }
                    </div>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {
                update_service !== null
                    ? <Update_serv_modal update_service={update_service} setupdate_service={setupdate_service}
                        setUrl_updated={setUrl_updated} departments={departments} available_habilitations={available_habilitations} />
                    : <></>
            }
        </>
    );
}

export default Services_list;